import { render, staticRenderFns } from "./age-month.vue?vue&type=template&id=63d70de0&"
import script from "./age-month.vue?vue&type=script&lang=js&"
export * from "./age-month.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports